<template>
  <v-card>
    <webp-supports-alert
      v-if="checkWebp"
      class="mr-5 ml-5 mt-5"
    />
    <v-slide-group
        class="pa-4"
        active-class="success"
        show-arrows
    >
      <v-slide-item
          v-for="(item, index) in items"
          :key="'item_' + index"
      >
        <v-card
            class="ma-4"
            width="120"
            @click="$emit('click', index, incident)"
        >
          <v-img :src="item.type === 'page' ? item.thumbnail_url : item.url">
            <template v-slot:placeholder>
              <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
              >
                <v-progress-circular
                    indeterminate
                    color="gray"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-slide-item>
      <v-slide-item
        v-if="bloodTransfusionSignature &&
              bloodTransfusionSignature.thumbnail"
      >
        <v-card
          class="ma-4"
          width="120"
          @click="showDocument(bloodTransfusionSignature.documentId)"
        >
          <v-img :src="bloodTransfusionSignature.thumbnail">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="gray"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-card>
</template>

<script>
import WebpSupportsAlert from '@/components/WebpSupportsAlert';

export default {
  name: 'HospitalIncidentGallery',
  components: { WebpSupportsAlert },
  props: {
    incident: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    bloodTransfusionSignature: {
      type: Object,
      required: true,
      default: null,
    },
    checkWebp: {
      type: Boolean,
      required: true,
      default: false,
    },
    showDocument: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
